<template>
    <v-container grid-list-md fluid fill-height>
        <v-layout row wrap style="width: 100%;">
            <v-flex >
                <v-card>
                    <statistics-marks-general-index :key="$route.fullPath"/>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import StatisticsMarksGeneralIndex
        from "@/components/admin/StatisticsMarks/StatisticsMarksGeneral/StatisticsMarksGeneralIndex";

    export default  {
        components: {
            StatisticsMarksGeneralIndex,
        },
        data: () => {
            return {
             

            };
        },
    }
</script>